import SecureAppWrapper from './SecureAppWrapper';

export default SecureAppWrapper;
